// App
import type React from 'react';
import { useState } from 'react';

// Misc / utils
import * as S from './styles';

interface BaseItemData {
  primaryText: string;
  secondaryText: string;
}

interface CommuteAutocompleteItemProps {
  item: BaseItemData;
  customRef: React.RefObject<HTMLLIElement>;
  handleSelectionClick: (item: BaseItemData) => void;
  handleSelectionKeyDown: (e: React.KeyboardEvent, item: BaseItemData) => void;
}

const CommuteAutocompleteItem: React.FC<CommuteAutocompleteItemProps> = ({
  item,
  customRef,
  handleSelectionClick,
  handleSelectionKeyDown,
}) => {
  // React
  const [isFocused, setIsFocused] = useState(false);

  const handleClick = () => handleSelectionClick(item);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => handleSelectionKeyDown(e, item);
  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  return (
    <S.Li
      aria-selected={isFocused}
      onBlur={handleBlur}
      onClick={handleClick}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
      ref={customRef}
      role="option"
      tabIndex={0}
    >
      <S.SuggestionPrimaryText>{item.primaryText}</S.SuggestionPrimaryText>
      <S.SuggestionSecondaryText>{item.secondaryText}</S.SuggestionSecondaryText>
    </S.Li>
  );
};

export default CommuteAutocompleteItem;
